import { render } from "./PortfolioTradeCard.vue?vue&type=template&id=1714c3ed&scoped=true&ts=true"
import script from "./PortfolioTradeCard.vue?vue&type=script&lang=ts"
export * from "./PortfolioTradeCard.vue?vue&type=script&lang=ts"

import "./PortfolioTradeCard.vue?vue&type=style&index=0&id=1714c3ed&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1714c3ed"]])

export default __exports__